import { app } from '../../../../../app';

app.factory('SaaspassConnectOverviewService', SaaspassConnectOverviewService);

/** @ngInject */
function SaaspassConnectOverviewService($resource) {
    var rootUrl = 'app/rest/admin/company/:companyId/saaspassconnects/:connectId';

    return {
        
        saaspassConnect : $resource(rootUrl,{},{'updateSaaspassConnect' : {
            method : 'PUT',
        }}),
        saaspassConnectDelete : $resource(rootUrl+ '/delete'),

    }
    

}



// WEBPACK FOOTER //
// ./src/portal/states/company/saaspass-connect/manage/overview/overview.service.js